/**
 * Mock implementation of the AppContainer component for web
 */
const React = require('react');

// Simple component that just renders its children
function AppContainer(props) {
  const { children, WrapperComponent, rootTag, ...rest } = props;
  return React.createElement('div', {
    style: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    },
    ...rest
  }, children);
}

module.exports = AppContainer;